import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { BaseShapeDataModel, ICTColorDmlA, IEGColorTransform, ISlideDataModel } from '@tencent/slide-sdk-model';
import _omit from 'lodash/omit';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { colorStrToColorDmlA, colorValueToColorDmlA } from '@src/slide/infrastructure/module/independent/color/transform';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import isNil from 'lodash/isNil';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ColorConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/color/color-converter';
import forEach from 'lodash/forEach';
/**
 * 根据数据中颜色信息动态生成最终的颜色（srgb_color）
 * @param elementModel
 * @param sdkData
 * @returns
 */
export function replaceSdkThemeColor(elementModel: IElementBaseModel, sdkData: object): object {
    let slide;
    if (elementModel?.parent?.type === UIModelType.TABLE) {
        slide = (elementModel.parent.sdkData as BaseShapeDataModel)?.getPage?.();
    } else {
        slide = elementModel.sdkData?.getPage?.();
    }
    if (!slide) {
        return sdkData;
    }
    findAndReplaceThemeKey(sdkData, slide);

    // 递归替换 sdk 数据中的主题色
    function findAndReplaceThemeKey(object, slide) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key of Object.keys(object || {})) {
            if (key === 'color' || key === 'clr1' || key === 'clr2') {
                const color = object[key];
                if (color.colorType === 'rgb') {
                    color.srgb_color = `#${color.colorValue}`;
                } else if (color.colorType === 'scheme') {
                    const colorDmlA = colorValueToColorDmlA(color.colorValue, _omit(color, ['colorType', 'colorValue']));
                    const srgb = SlideDataServices.SDKDataServices.ColorManager()
                        ?.resolveColor(colorDmlA as unknown as ICTColorDmlA, slide)?.srgbClr?.val;
                    color.srgb_color = `#${srgb}`;
                }
            }  else if (typeof object[key] === 'object') {
                findAndReplaceThemeKey(object[key], slide);
            }
        }
    }
    return sdkData;
}

export function replaceSrgbColorTDColor(target, slideModel: ISlideModel) {
    // eslint-disable-next-line no-restricted-syntax
    forEach(target, (value, key) => {
        if ((key === 'color' || key === 'tdColor') && value instanceof TDColor) {
            const srgbColor = getSrgbColorFromTDColor(value, slideModel);
            value.srgbColor = srgbColor;
            if (key === 'tdColor') {
                target.color = srgbColor;
            }
        }  else if (typeof value === 'object') {
            replaceSrgbColorTDColor(value, slideModel);
        }
    });
    return target;
}

export function getSrgbColorFromTDColor(tdColor: ITDColor, slideModel: ISlideModel) {
    if (tdColor.srgbColor) return tdColor.srgbColor;
    const colorSdk = {};
    ColorConverter.convertPartialDataFromUiToSdk(
        tdColor,
        colorSdk,
    );
    const colorStr =  SlideDataServices.SDKDataServices.ColorManager()?.resolveColor(
        colorSdk,
        slideModel?.sdkData as ISlideDataModel,
    )?.srgbClr?.val;
    return colorStr ? `#${colorStr}` : '';
}
